import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "border-0 rounded-lg h-full relative flex flex-col w-full bg-white outline-none focus:outline-none" }
const _hoisted_2 = { class: "flex flex-col gap-4 fixed top-5 right-5 w-3/5 lg:w-2/5 xl:w-1/5" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center w-12 bg-green-500\"><svg class=\"w-6 h-6 text-white fill-current\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z\"></path></svg></div><div class=\"px-4 py-2 -mx-3\"><div class=\"mx-3\"><span class=\"font-semibold text-green-500 dark:text-green-400\">Success</span><p class=\"text-sm text-gray-600 dark:text-gray-200\"> Coppy Success </p></div></div>", 2)
const _hoisted_5 = [
  _hoisted_3
]
const _hoisted_6 = {
  key: 0,
  id: "payment_mobile",
  class: "outline-none focus:outline-none h-full"
}
const _hoisted_7 = { class: "border rounded-md border-gray-100 pt-6 pb-10 px-6 z-10 relative" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createTextVNode(" เลือกวิธีชำระเงิน "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_10 = {
  key: 1,
  class: "flex gap-4 mb-4"
}
const _hoisted_11 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_12 = { class: "flex space-x-4 items-center h-full relative" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  id: "radSelect",
  name: "radSelect",
  checked: ""
}, null, -1)
const _hoisted_14 = ["src", "onerror"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex-1 w-20 flex flex-col text-left gap-1" }
const _hoisted_17 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_20 = {
  key: 1,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_21 = { class: "flex flex-col text-left gap-1" }
const _hoisted_22 = { class: "text-xs md:text-sm text-gray-500 opacity-70 clamp-1" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm md:text-md text-gray-500 font-semibold"
}
const _hoisted_24 = {
  key: 1,
  class: "text-md text-gray-500 font-semibold"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(22141 4199)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_2086",
      "data-name": "Rectangle 2086",
      width: "24",
      height: "24",
      transform: "translate(-22141 -4199)",
      fill: "#fff",
      opacity: "0"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Icon_awesome-copy",
      "data-name": "Icon awesome-copy",
      d: "M11.438,16.014v1.43a.858.858,0,0,1-.858.858H.858A.858.858,0,0,1,0,17.443V4.289a.858.858,0,0,1,.858-.858H3.432v10.58a2,2,0,0,0,2,2Zm0-12.3V0H5.433a.858.858,0,0,0-.858.858V14.012a.858.858,0,0,0,.858.858h9.723a.858.858,0,0,0,.858-.858V4.575H12.3A.86.86,0,0,1,11.438,3.717Zm4.324-1.109L13.405.251A.858.858,0,0,0,12.8,0h-.217V3.432h3.432V3.215a.858.858,0,0,0-.251-.607Z",
      transform: "translate(-22137.008 -4196.15)",
      fill: "#bababa"
    })
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "flex space-x-4 items-center h-full relative" }
const _hoisted_30 = ["checked"]
const _hoisted_31 = ["src", "onerror"]
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "w-full flex flex-col text-left gap-1" }
const _hoisted_34 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_35 = { class: "flex justify-between" }
const _hoisted_36 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_37 = {
  key: 1,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_38 = { class: "flex flex-col text-left gap-1" }
const _hoisted_39 = { class: "text-xs md:text-sm text-gray-500 opacity-70 clamp-1" }
const _hoisted_40 = {
  key: 0,
  class: "text-sm md:text-md text-gray-500 font-semibold"
}
const _hoisted_41 = {
  key: 1,
  class: "text-md text-gray-500 font-semibold"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(22141 4199)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_2086",
      "data-name": "Rectangle 2086",
      width: "24",
      height: "24",
      transform: "translate(-22141 -4199)",
      fill: "#fff",
      opacity: "0"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Icon_awesome-copy",
      "data-name": "Icon awesome-copy",
      d: "M11.438,16.014v1.43a.858.858,0,0,1-.858.858H.858A.858.858,0,0,1,0,17.443V4.289a.858.858,0,0,1,.858-.858H3.432v10.58a2,2,0,0,0,2,2Zm0-12.3V0H5.433a.858.858,0,0,0-.858.858V14.012a.858.858,0,0,0,.858.858h9.723a.858.858,0,0,0,.858-.858V4.575H12.3A.86.86,0,0,1,11.438,3.717Zm4.324-1.109L13.405.251A.858.858,0,0,0,12.8,0h-.217V3.432h3.432V3.215a.858.858,0,0,0-.251-.607Z",
      transform: "translate(-22137.008 -4196.15)",
      fill: "#bababa"
    })
  ])
], -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { key: 2 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณาเลือกวิธีชำระเงิน"), -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 0,
  class: "border rounded-md border-gray-100 p-6 mt-4 flex flex-col gap-4"
}
const _hoisted_49 = { class: "flex-1 flex justify-center" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  class: "svg-inline--fa fa-times fa-w-11",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "flex flex-col gap-2 items-center justify-center w-full h-full" }
const _hoisted_53 = ["src"]
const _hoisted_54 = {
  key: 0,
  class: "text-gray-300"
}
const _hoisted_55 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", null, "QR Code", -1)
const _hoisted_57 = ["src"]
const _hoisted_58 = {
  key: 0,
  class: "flex flex-col gap-2 min-w-64 max-w-72"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, "QR Code", -1)
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "พร้อมเพย์", -1)
const _hoisted_62 = { class: "flex flex-wrap gap-2" }
const _hoisted_63 = { class: "text-center" }
const _hoisted_64 = { class: "mx-auto" }
const _hoisted_65 = ["href"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-download text-gray-400 hover:text-green-mint-500 text-base items-center text-center focus:ring-0 focus:outline-none w-3 h-3" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  key: 1,
  class: "flex justify-center items-center min-h-64"
}
const _hoisted_69 = ["src"]
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center justify-center text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณาอัพโหลดสลิป"), -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { key: 1 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("- ประเภทของไฟล์ไม่ถูกต้อง (รองรับเฉพาะ jpg, jpeg, png)"), -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("- ไฟล์ของคุณขนาดเกิน 2.0 MB"), -1)
const _hoisted_76 = [
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = { class: "flex-1 flex flex-col gap-2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", { class: "" }, "รายละเอียดการชำระเงิน", -1)
const _hoisted_79 = { class: "flex flex-col space-y-2" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" จำนวนเงิน "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_81 = { class: "w-full sm:w-96 relative" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณากรอกจำนวนเงิน"), -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { class: "flex flex-col sm:flex-row gap-4" }
const _hoisted_86 = { class: "flex flex-col space-y-2" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" วันที่ชำระ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_88 = { class: "w-full relative" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500 absolute" }, /*#__PURE__*/_toDisplayString("* กรุณากรอกวันที่ชำระ"), -1)
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { class: "flex flex-col space-y-2 flex-wrap" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" เวลาที่ชำระ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_94 = { class: "relative" }
const _hoisted_95 = { class: "flex flex-row space-x-1 items-end" }
const _hoisted_96 = { class: "flex items-end gap-2 w-full" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("p", null, "น.", -1)
const _hoisted_98 = { key: 0 }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500 absolute" }, /*#__PURE__*/_toDisplayString("* กรุณากรอกเวลาที่ชำระ"), -1)
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" แนบไฟล์ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_103 = { class: "relative" }
const _hoisted_104 = { class: "flex gap-2 items-center" }
const _hoisted_105 = ["src"]
const _hoisted_106 = { key: 0 }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณาอัพโหลดสลิป"), -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = { key: 1 }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("- ประเภทของไฟล์ไม่ถูกต้อง (รองรับเฉพาะ jpg, jpeg, png)"), -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("small", { class: "mt-2 flex gap-1 items-center text-red-500" }, /*#__PURE__*/_toDisplayString("- ไฟล์ของคุณขนาดเกิน 2.0 MB"), -1)
const _hoisted_112 = [
  _hoisted_110,
  _hoisted_111
]
const _hoisted_113 = { class: "flex items-center gap-2 mt-4" }
const _hoisted_114 = ["src"]
const _hoisted_115 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 10.155 11.606"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Icon_awesome-trash",
    "data-name": "Icon awesome-trash",
    d: "M9.793.725H7.072L6.859.3A.544.544,0,0,0,6.372,0H3.781A.538.538,0,0,0,3.3.3L3.083.725H.363A.363.363,0,0,0,0,1.088v.725a.363.363,0,0,0,.363.363h9.43a.363.363,0,0,0,.363-.363V1.088A.363.363,0,0,0,9.793.725ZM1.206,10.586a1.088,1.088,0,0,0,1.086,1.02H7.864a1.088,1.088,0,0,0,1.086-1.02L9.43,2.9H.725Z",
    fill: "#9ba3b0"
  })
], -1)
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = {
  key: 1,
  class: "flex flex-col space-x-1 space-y-2"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, "หมายเหตุ", -1)
const _hoisted_120 = {
  key: 1,
  class: "border rounded-md bg-gray-100 p-6 mt-4 flex flex-col sm:flex-row gap-4 justify-center items-center",
  style: {"height":"300px"}
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fileUpload = _resolveComponent("fileUpload")!
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.chkPaymentStatus() && _ctx.data.paymentAttachmentData && _ctx.uploadAgain)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trigger())),
          class: "group relative w-full flex justify-center py-4 px-4 border border-transparent text-lg font-medium rounded-md text-white bg-green-island-500 hover:bg-green-island-600 focus:outline-none focus:ring-transparent"
        }, " อัพโหลดสลิปใหม่ "))
      : _createCommentVNode("", true),
    (!_ctx.uploadAgain)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["relative w-full min-h-full mb-4", _ctx.selPayment ? 'h-full' : 'h-auto'])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogCopyArr, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "flex w-full max-w-sm bg-white rounded-lg shadow-md z-50 dark:bg-gray-800"
                }, _hoisted_5))
              }), 128))
            ]),
            (_ctx.data)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.data.paymentAttachmentData)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trigger())),
                          class: "absolute top-4 right-4 cursor-pointer"
                        }, [
                          _createElementVNode("img", {
                            class: "w-3",
                            src: require('@/assets/images/close.svg'),
                            alt: ""
                          }, null, 8, _hoisted_8)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_9,
                    (_ctx.data.paymentAvailableData.length !== 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_ctx.hasLength(_ctx.data.paymentAvailableData, 'bankDeposit'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (
                (_ctx.isSelectTypePayment = 'bankDeposit'),
                  _ctx.selectChannel(_ctx.data.paymentAvailableData, 'bankDeposit')
              )),
                                class: _normalizeClass(["rounded-md p-2 border", 
                _ctx.isSelectTypePayment === 'bankDeposit'
                  ? 'border-green-island-500 bg-green-island-100 text-green-island-500'
                  : 'border-gray-300 text-gray-300'
              ])
                              }, " ธนาคาร ", 2))
                            : _createCommentVNode("", true),
                          (_ctx.hasLength(_ctx.data.paymentAvailableData, 'cash'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (
                (_ctx.isSelectTypePayment = 'cash'),
                  _ctx.selectChannel(_ctx.data.paymentAvailableData, 'cash')
              )),
                                class: _normalizeClass(["rounded-md p-2 border", 
                _ctx.isSelectTypePayment === 'cash'
                  ? 'border-green-island-500 bg-green-island-100 text-green-island-500'
                  : 'border-gray-300 text-gray-300'
              ])
                              }, " เงินสด ", 2))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.paymentList.length == 1)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.paymentList, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.paymentMethodId,
                              class: "border-2 rounded-md border-green-island-500 bg-green-island-100 p-2",
                              style: {"min-height":"96px"}
                            }, [
                              _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                (item.paymentIconUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "min-w-10 max-w-10 min-h-10 max-h-10 md:min-w-16 md:max-w-16 md:min-h-16 md:max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                      src: 
                      _ctx.envMedia +
                      '/public/' +
                      (item.paymentMethodType !== 'cash'
                        ? item.paymentIconUrl
                        : 'icons/payment/cash.webp')
                    ,
                                      alt: "",
                                      onerror: `this.src='${_ctx.envMedia}/public/icons/payment/cash.webp'`
                                    }, null, 8, _hoisted_14))
                                  : _createCommentVNode("", true),
                                (!item.paymentIconUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      class: "min-w-16 max-w-16 min-h-16 max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                      src: `${_ctx.envMedia}/public/icons/payment/cash.webp`,
                                      alt: ""
                                    }, null, 8, _hoisted_15))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_16, [
                                  (item.paymentMethodType === 'cash')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.paymentAliasName), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_18, [
                                          (item.paymentMethodType === 'bankDeposit')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.convertBankName(
                              item.paymentMethodAttribute.bankAccountName
                            )) + " " + _toDisplayString(item.paymentMethodAttribute.branchName
                              ? "(" +
                                item.paymentMethodAttribute.branchName +
                                ")"
                              : "") + " ", 1))
                                            : _createCommentVNode("", true),
                                          (item.paymentMethodType === 'promptPay')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, " พร้อมเพย์ "))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_21, [
                                          _createElementVNode("p", _hoisted_22, _toDisplayString(item.paymentMethodAttribute.accountName), 1),
                                          (item.paymentMethodType === 'bankDeposit')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.paymentNumber(item.paymentMethodAttribute.accountNo)), 1))
                                            : _createCommentVNode("", true),
                                          (item.paymentMethodType === 'promptPay')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.promptPayNumber(
                                item.paymentMethodAttribute.accountNo,
                                item.paymentMethodAttribute.promptPayType
                              )), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 64))
                                ]),
                                (item.paymentMethodType !== 'cash')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      onClick: ($event: any) => (_ctx.copyLink(item)),
                                      class: "inline-flex w-10 justify-center bg-gray-100 p-2 shadow-md rounded-full cursor-pointer right-0"
                                    }, _hoisted_27, 8, _hoisted_25))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.paymentList, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.paymentMethodId,
                              onClick: ($event: any) => (_ctx.selectBank(item.paymentMethodId, item)),
                              class: _normalizeClass([
                  _ctx.selPayment === item.paymentMethodId
                    ? 'border-green-island-500  bg-green-island-100'
                    : 'opacity-25'
                , "cursor-pointer border-2 rounded-md border-gray-100 p-2"]),
                              style: {"min-height":"96px"}
                            }, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("input", {
                                  checked: _ctx.selPayment === item.paymentMethodId,
                                  type: "radio",
                                  id: "radSelect",
                                  name: "radSelect"
                                }, null, 8, _hoisted_30),
                                (item.paymentIconUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "min-w-10 max-w-10 min-h-10 max-h-10 md:min-w-16 md:max-w-16 md:min-h-16 md:max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                      src: 
                      _ctx.envMedia +
                      '/public/' +
                      (item.paymentMethodType !== 'cash'
                        ? item.paymentIconUrl
                        : 'icons/payment/cash.webp')
                    ,
                                      alt: "",
                                      onerror: `this.src='${_ctx.envMedia}/public/icons/payment/cash.webp'`
                                    }, null, 8, _hoisted_31))
                                  : _createCommentVNode("", true),
                                (!item.paymentIconUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      class: "min-w-16 max-w-16 min-h-16 max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                      src: `${_ctx.envMedia}/public/icons/payment/cash.webp`,
                                      alt: ""
                                    }, null, 8, _hoisted_32))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_33, [
                                  (item.paymentMethodType === 'cash')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(item.paymentAliasName), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_35, [
                                          (item.paymentMethodType === 'bankDeposit')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.convertBankName(
                              item.paymentMethodAttribute.bankAccountName
                            )) + " " + _toDisplayString(item.paymentMethodAttribute.branchName
                              ? "(" +
                                item.paymentMethodAttribute.branchName +
                                ")"
                              : "") + " ", 1))
                                            : _createCommentVNode("", true),
                                          (item.paymentMethodType === 'promptPay')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_37, " พร้อมเพย์ "))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_38, [
                                          _createElementVNode("p", _hoisted_39, _toDisplayString(item.paymentMethodAttribute.accountName), 1),
                                          (item.paymentMethodType === 'bankDeposit')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.paymentNumber(item.paymentMethodAttribute.accountNo)), 1))
                                            : _createCommentVNode("", true),
                                          (item.paymentMethodType === 'promptPay')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.promptPayNumber(
                                item.paymentMethodAttribute.accountNo,
                                item.paymentMethodAttribute.promptPayType
                              )), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 64))
                                ]),
                                (item.paymentMethodType !== 'cash')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      onClick: ($event: any) => (_ctx.copyLink(item)),
                                      class: "inline-flex w-10 justify-center bg-gray-100 p-2 shadow-md rounded-full cursor-pointer right-0"
                                    }, _hoisted_44, 8, _hoisted_42))
                                  : _createCommentVNode("", true)
                              ])
                            ], 10, _hoisted_28))
                          }), 128))
                    ]),
                    (_ctx.checkSelectPayment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                      : _createCommentVNode("", true)
                  ]),
                  (
            _ctx.selPayment &&
            _ctx.dataitempayment &&
            _ctx.dataitempayment.paymentMethodType !== 'cash' && 
            _ctx.currentChannels === 'bankDeposit'
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          (
                _ctx.dataitempayment.paymentMethodType !== 'promptPay' &&
                _ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl === ''
              )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", {
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.$refs.uploadImage.clickFile && _ctx.$refs.uploadImage.clickFile(...args))),
                                  class: "cursor-pointer flex justify-center items-center relative rounded-md border-2 border-gray-200",
                                  style: {"width":"201px","background":"rgb(247 247 247)","height":"311px"}
                                }, [
                                  (_ctx.dataslipimageUrl)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => {
                    _ctx.$refs.uploadImage.deleteUrl();
                    _ctx.deleteUrlImage();
                  }),
                                        class: "absolute top-1 right-2 w-4 text-red-500 cursor-pointer"
                                      }, _hoisted_51))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("img", {
                                      class: _normalizeClass(["object-contain mx-auto", _ctx.dataslipimageUrl ? 'w-full h-full' : '']),
                                      src: 
                      _ctx.dataslipimageUrl
                        ? _ctx.prefixUrlImage + _ctx.dataslipimageUrl
                        : require('@/assets/images/upload_image.svg')
                    ,
                                      alt: ""
                                    }, null, 10, _hoisted_53),
                                    (!_ctx.dataslipimageUrl)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_54, " รูปหลักฐานการโอน "))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createVNode(_component_fileUpload, {
                                  ref: "uploadImage",
                                  class: "hidden",
                                  onUploadFile: _ctx.getLogoUrl,
                                  onFileName: _ctx.getFileName
                                }, null, 8, ["onUploadFile", "onFileName"])
                              ], 64))
                            : _createCommentVNode("", true),
                          (
                _ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl !== ''
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _hoisted_56,
                                _createElementVNode("img", {
                                  class: "rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                  src: `${_ctx.prefixUrlImage}public/${_ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl}`,
                                  style: {"height":"322px","width":"182px"},
                                  alt: ""
                                }, null, 8, _hoisted_57)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.dataitempayment.paymentMethodType === 'promptPay')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_ctx.promptPayQrCodeImg)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _hoisted_59,
                                      _createElementVNode("img", {
                                        class: "object-contain w-full bg-gray-100",
                                        src: _ctx.promptPayQrCodeImg,
                                        style: {"width":"250px","height":"250px"},
                                        alt: ""
                                      }, null, 8, _hoisted_60),
                                      _hoisted_61,
                                      _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.dataitempayment.paymentMethodAttribute?.accountName) + " (ยอดชำระ " + _toDisplayString(_ctx.paymentPrice) + ") ", 1),
                                        _createElementVNode("div", _hoisted_64, [
                                          _createElementVNode("a", {
                                            target: "_blank",
                                            href: _ctx.promptPayQrCodeImg,
                                            download: ""
                                          }, _hoisted_67, 8, _hoisted_65)
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                      _createElementVNode("img", {
                                        class: "w-32 h-32",
                                        src: require('@/assets/images/animation_loading.gif')
                                      }, null, 8, _hoisted_69)
                                    ]))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.checkUploadimg)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_72))
                          : _createCommentVNode("", true),
                        (_ctx.checkUploadimgType)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_76))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_77, [
                          _hoisted_78,
                          _createElementVNode("div", _hoisted_79, [
                            _hoisted_80,
                            _createElementVNode("div", _hoisted_81, [
                              _createVNode(_component_currency_input, {
                                modelValue: _ctx.paymentPrice,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paymentPrice) = $event)),
                                options: { currency: 'USD', currencyDisplay: 'hidden' }
                              }, null, 8, ["modelValue"]),
                              (_ctx.paymentPriceChk)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("form", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _hoisted_87,
                              _createElementVNode("div", _hoisted_88, [
                                _createVNode(_component_Calendar, {
                                  id: "calendar-timeDate",
                                  modelValue: _ctx.selectedDate,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDate) = $event)),
                                  showIcon: "",
                                  dateFormat: "dd/mm/yy",
                                  onDateSelect: _ctx.validator,
                                  onInput: _ctx.validator
                                }, null, 8, ["modelValue", "onDateSelect", "onInput"]),
                                (_ctx.crtlDateChk)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, _hoisted_91))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_92, [
                              _hoisted_93,
                              _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("div", _hoisted_95, [
                                  _createElementVNode("div", _hoisted_96, [
                                    _createVNode(_component_Calendar, {
                                      id: "calendar-timeonly",
                                      modelValue: _ctx.selectedTime,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTime) = $event)),
                                      timeOnly: "",
                                      showIcon: "",
                                      icon: "pi pi-clock",
                                      onDateSelect: _ctx.validator,
                                      onInput: _ctx.validator
                                    }, null, 8, ["modelValue", "onDateSelect", "onInput"]),
                                    _hoisted_97
                                  ])
                                ]),
                                (_ctx.crtlTimeChk)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, _hoisted_100))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          (
                _ctx.dataitempayment.paymentMethodType === 'promptPay' ||
                (_ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                  _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl !== '')
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                _hoisted_102,
                                _createElementVNode("div", _hoisted_103, [
                                  _createElementVNode("button", {
                                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.$refs.uploadImage.clickFile && _ctx.$refs.uploadImage.clickFile(...args))),
                                    class: "btn_upload_mini",
                                    style: {"height":"40px"}
                                  }, [
                                    _createElementVNode("div", _hoisted_104, [
                                      _createElementVNode("img", {
                                        class: "w-4",
                                        src: require('@/assets/images/upload_image.svg'),
                                        alt: ""
                                      }, null, 8, _hoisted_105),
                                      _createTextVNode(" อัพโหลดรูปภาพ ")
                                    ])
                                  ]),
                                  _createVNode(_component_fileUpload, {
                                    ref: "uploadImage",
                                    class: "hidden",
                                    onUploadFile: _ctx.getLogoUrl,
                                    onFileName: _ctx.getFileName
                                  }, null, 8, ["onUploadFile", "onFileName"]),
                                  (_ctx.checkUploadimg)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, _hoisted_108))
                                    : _createCommentVNode("", true),
                                  (_ctx.checkUploadimgType)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, _hoisted_112))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_113, [
                                  _createElementVNode("img", {
                                    class: "object-contain w-16 h-14",
                                    src: 
                    _ctx.dataslipimageUrl
                      ? _ctx.prefixUrlImage + _ctx.dataslipimageUrl
                      : require('@/assets/images/upload_image.svg')
                  ,
                                    alt: ""
                                  }, null, 8, _hoisted_114),
                                  (_ctx.dataslipimageUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                        _createTextVNode(_toDisplayString(_ctx.fileName) + " ", 1),
                                        _createElementVNode("div", {
                                          onClick: _cache[10] || (_cache[10] = ($event: any) => {
                      _ctx.$refs.uploadImage.deleteUrl();
                      _ctx.deleteUrlImage();
                    })
                                        }, _hoisted_117)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (
                _ctx.dataitempayment.paymentMethodType === 'bankDeposit' &&
                _ctx.dataitempayment.paymentMethodAttribute?.qrImagesUrl === '' &&
                _ctx.dataitempayment.paymentMethodType !== 'promptPay'
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                _hoisted_119,
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.note) = $event)),
                                  class: "resize-none focus:ring-green-island-500 focus:ring-2 focus:border-transparent border rounded-md border-gray-100 p-4"
                                }, null, 512), [
                                  [_vModelText, _ctx.note]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
            _ctx.dataitempayment &&
            _ctx.dataitempayment.paymentMethodType === 'cash' &&
            _ctx.currentChannels === 'cash'
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, " กรุณาชำระเงินสดที่เคาน์เตอร์ "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.chkPaymentStatus())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(
          _ctx.data.paymentAttachmentData
            ? 'bottom-0 left-0  w-full z-20 p-3 xl:p-0 bg-white xl:bg-unset flex flex-row'
            : ' fixed bottom-0 left-0 w-full z-20 p-3 xl:p-0 bg-white xl:bg-unset xl:relative flex flex-row'
        )
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.btnOkClick())),
                    class: "group relative w-full flex justify-center py-4 px-4 border border-transparent text-lg font-medium rounded-md text-white bg-green-island-500 hover:bg-green-island-600 focus:outline-none focus:ring-transparent"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.data.paymentAttachmentData
              ? "แจ้งการชำระเงินใหม่"
              : "แจ้งการชำระเงิน") + " ", 1),
                    _hoisted_121,
                    _createTextVNode(" (" + _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.totalPayAmount)) + " บาท) ", 1)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}